<template>
  <v-layout row wrap>
    <v-flex class="xs12">
      <h2
        class="title mx-4 mt-4 mb-1 text-xs-left"
        style="font-weight:400;"
      >Visualizar relatórios dos grupos de despesas</h2>
      <div
        class="caption text-xs-left pb-3 px-4"
      >Preencha os filtros abaixo e selecione o relatório desejado</div>
    </v-flex>
    <v-flex xs2 px-3>
      <v-menu
        v-model="initDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date_init_formated"
            label="Data inicial"
            return-masked-value
            mask="##/####"
            clearable
            v-on="on"
            :rules="$store.state.formRules.required"
          ></v-text-field>
        </template>
        <v-date-picker type="month" no-title v-model="date_init" @input="initDateMenu = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs2>
      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date_end_formated"
            label="Data final"
            return-masked-value
            mask="##/####"
            clearable
            v-on="on"
            :rules="$store.state.formRules.required"
          ></v-text-field>
        </template>
        <v-date-picker type="month" no-title v-model="date_end" @input="endDateMenu = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <!-- <v-flex xs2 pl-4>
      <v-text-field ref="iptYear" v-model="year" label="Ano de vigência" mask="####"></v-text-field>
    </v-flex>-->
    <v-flex xs3 px-4>
      <v-autocomplete
        v-model="condominium_id"
        :items="condominiumsList"
        item-text="name_fantasy"
        item-value="id"
        @change="getIndex"
        label="Selecione o condomínio"
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>
    <v-flex xs2>
      <v-autocomplete
        v-model="financial_id"
        :items="financialList"
        :disabled="!condominium_id"
        item-text="name"
        item-value="id"
        @change="getAccounts"
        label="Selecione um índice"
      ></v-autocomplete>
    </v-flex>
    <v-flex xs3 pl-4>
      <v-autocomplete
        v-model="account_id"
        :items="accountsList"
        :disabled="!financial_id"
        item-text="account_name"
        item-value="id"
        label="Selecione uma conta"
      ></v-autocomplete>
    </v-flex>
    <v-flex xs2>
      <v-sheet class="pa-5" color="white">
        <v-sheet
          elevation="3"
          :class="['btSheet mx-auto pa-2', !account_id ? 'disab' : '']"
          height="100"
          width="100"
          @click="account_id ? openChartArea('budget') : null"
        >
          <v-icon size="48" class="blue--text text--lighten-2 pt-2">attach_money</v-icon>
          <h2 class="caption">
            <b>Orçamento</b>
          </h2>
        </v-sheet>
      </v-sheet>
    </v-flex>
    <v-flex xs2>
      <v-sheet class="pa-5" color="white">
        <v-sheet
          elevation="3"
          :class="['btSheet mx-auto pa-2', !account_id ? 'disab' : '']"
          height="100"
          width="100"
          @click="account_id ? openChartArea('realized') : null"
        >
          <v-icon size="48" class="teal--text text--lighten-1 pt-2">assignment_turned_in</v-icon>
          <h2 class="caption">
            <b>Realizado</b>
          </h2>
        </v-sheet>
      </v-sheet>
    </v-flex>
    <v-flex xs2>
      <ChartArea
        :queryAccountPlans="queryAccountPlans"
        :items="expGroupList"
        :dataSeries="dataSeries"
        :chartAreaDialog="chartAreaDialog"
        :closeChartArea="closeChartArea"
        :titleChart="titleChart"
      />
      <v-sheet class="pa-5" color="white">
        <v-sheet
          elevation="1"
          :class="['btSheet mx-auto pa-2', !account_id ? 'disab' : '']"
          height="100"
          width="100"
          @click="account_id ? openChartArea('comparative') : null"
        >
          <v-icon size="48" class="deep-orange--text text--darken-1 pt-2">pie_chart</v-icon>
          <h2 class="caption deep-orange--text text--darken-1">
            <b>Comparativo</b>
          </h2>
        </v-sheet>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
import ChartArea from './ChartArea'
import * as moment from 'moment'
export default {
  components: {
    ChartArea
  },
  computed: {
    date_init_formated: {
      get () {
        return this.date_init ? moment(this.date_init).format('MM/YYYY') : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          this.date_init = moment(`${value.split('/')[0]}/${value}`).format(
            'YYYY-MM'
          )
        } else {
          this.date_init = ''
        }
      }
    },
    date_end_formated: {
      get () {
        return this.date_end ? moment(this.date_end).format('MM/YYYY') : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          this.date_end = moment(`${value.split('/')[0]}/${value}`).format(
            'YYYY-MM'
          )
        } else {
          this.date_end = ''
        }
      }
    }
  },
  props: {
    condominiumsList: Array
  },
  data () {
    return {
      initDateMenu: false,
      endDateMenu: false,
      queryAccountPlans: {},
      accountsList: [],
      account_id: '',
      dataSeries: [],
      expGroupList: [],
      // year: "",
      date_init: '',
      date_end: '',
      condominium_id: '',
      financial_id: '',
      financialList: [],
      chartAreaDialog: false,
      titleChart: ''
    }
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },
    openChartArea (type) {
      // if (!this.year) {
      //   this.$nextTick(() => this.$refs.iptYear.focus());
      //   return;
      // }
      this.chartAreaDialog = true
      this.titleChart = type
      this.getExpenseGroups(type)
    },
    closeChartArea () {
      this.chartAreaDialog = false
      this.titleChart = ''
    },

    getIndex () {
      this.financial_id = ''
      this.account_id = ''
      let queryParams = {}
      queryParams.params = {
        condominium_id: this.condominium_id
      }

      let obj = {
        url: '/api/financial',
        query: queryParams,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        console.log('asdasdasd')
        this.financialList = response.data
      })
    },
    getAccounts () {
      this.account_id = ''
      let dataSearch = {}
      dataSearch.params = {
        condominium_id: this.condominium_id,
        financial_id: this.financial_id
      }
      let obj = {
        url: '/api/financialAccount',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.accountsList = response.data
      })
    },
    getExpenseGroups (type) {
      this.dataSeries = []
      let dataSearch = {}
      dataSearch.params = {
        date_init: this.date_init,
        date_end: this.date_end,
        financial_id: this.financial_id,
        account_id: this.account_id,
        year: this.year
      }

      let url = type == 'budget' ? '/api/budget' : '/api/realized'

      if (type == 'comparative') {
        this.queryAccountPlans = { ...dataSearch.params }
        url = '/api/ListUsedGroups'
      }
      let obj = {
        url: url,
        query: type == 'comparative' ? dataSearch.params : dataSearch,
        method: type == 'comparative' ? 'post' : 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (type == 'comparative') {
          this.expGroupList = response.data
        } else {
          this.expGroupList = response.data.map((data) => {
            let obj = {
              name: data.referenceDesecription,
              data: data.months,
              ref: `${data.referenceCode} ${data.referenceDesecription}`
            }
            this.dataSeries.push(obj)
            return `${data.referenceCode} ${data.referenceDesecription}`
          })
        }
        console.log('dataseries', this.dataSeries)
      })
    }
  }
}
</script>

<style>
.btSheet {
  cursor: pointer !important;
  border-radius: 5px;
}

.disab {
  opacity: 0.4 !important;
  cursor: auto;
}
</style>
